import React from 'react';
import { Checkbox as MuiCheckbox } from '@mui/material';

const Checkbox = (props) => {
  return <MuiCheckbox {...props} />;
};

export default Checkbox;
